const WebTheme = {
    colors: {
        /*Colores de letra segun el tema de color */
        letraDark:'white',
        letraGreen:'black',
        letraGreenRotulo:'#8b4513',
        optionBlue:'#3333FF',
        /*Colores de fondo */
        backgroundGreen:'darkSeaGreen',
        backgroundDark:'DarkGrey',
        backgroundHoverGreen:'#00FF80',
        backgroundHoverCyan:'#A2F4FD'
    },

    borderLines:{
        /*Colores de linea segun el tema de color */
        lineaDark:'solid 2px orange',
        lineaGreen:'solid 2px green',
    },
    fontSizes: {
        small:'large',
        mediano:'x-large',
        grande:'xx-large'

    },
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
    },
    borderRadius: {
        small: '4px',
        medium: '8px',
        large: '16px',
    },
    lineWidth: {
        thin: '1px',
        normal: '2px',
        thick: '4px',
    },
};

export default WebTheme;